import { WithContextProps } from 'business/models/CustomModels';
import React from 'react';
import { MenuProvider } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
import Renderers from 'react-virtualized-tree/lib/renderers';

const { Expandable } = Renderers;

export default function WithContext(Component) {
  return (props: WithContextProps) => {
    const NodeMenu = props.menu;

    return (
      <div id="withcontextmenu-container">
        <MenuProvider id={props.data.id}>
          <Expandable node={props.data} {...props.rest}>
            <Component {...props} />
            {props.children}
          </Expandable>
        </MenuProvider>
        <NodeMenu />
      </div>
    );
  };
}
